import React, { useRef } from 'react';
import useSetState from '../../../hooks/useSetState';
import RseeTimePicker from '../../../components/timePicker';

const CafeTimesFilters = ({ applyFilters, getAllReservationHours }) => {
  let formRefrence = useRef();

  const [controls, setControls] = useSetState({
    fromTime: '00:00',
    toTime: '23:45',
    tableNumber: '',
    tableTitle: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const onSubmit = event => {
    event.preventDefault();
    applyFilters(event);
  };

  const onReset = () => {
    onChangeValue('fromTime', '00:00');
    onChangeValue('toTime', '23:45');
    onChangeValue('tableNumber', '');
    onChangeValue('tableTitle', '');
    getAllReservationHours();
  };

  return (
    <section>
      <form
        ref={formRefrence}
        onSubmit={event => onSubmit(event)}
        id='filterForm'
        className='card card my-4'
      >
        <header className='text-center card-header'>
          <h5 className='font-italic text-muted'>{locales('titles.filter')}</h5>
        </header>
        <main className='card-body'>
          <div className='d-flex row flex-sm-column col-12 flex-md-row px-1 mx-1'>
            <div className='form-group d-flex col-md-5 col-sm-12 mx-1'>
              <label className='rsee-form-label'>
                {locales('tables.fromHour')}
              </label>
              <div className='full-width'>
                <RseeTimePicker
                  name='fromTime'
                  className='form-control'
                  onChange={event => onChangeValue('fromTime', event)}
                  value={controls.fromTime}
                />
              </div>
            </div>
            <div className='form-group d-flex col-md-5 col-sm-12 mx-1'>
              <label className='rsee-form-label'>
                {locales('tables.toHour')}
              </label>
              <div className='full-width'>
                <RseeTimePicker
                  name='toTime'
                  className='form-control'
                  onChange={event => onChangeValue('toTime', event)}
                  value={controls.toTime}
                />
              </div>
            </div>
          </div>

          <div className='d-flex row flex-sm-column col-12 flex-md-row px-1 mx-1'>
            <div className='form-group d-flex col-md-5 col-sm-12 mx-1'>
              <label className='rsee-form-label'>
                {locales('tables.tableNumber')}
              </label>
              <div className='full-width'>
                <input
                  name='tableNumber'
                  type='number'
                  className='form-control'
                  value={controls.tableNumber}
                  onChange={event =>
                    onChangeValue('tableNumber', event.target.value)
                  }
                />
              </div>
            </div>
            <div className='form-group d-flex col-md-5 col-sm-12 mx-1'>
              <label className='rsee-form-label'>
                {locales('table.title')}
              </label>
              <div className='full-width'>
                <input
                  name='tableTitle'
                  type='text'
                  className='form-control'
                  value={controls.tableTitle}
                  onChange={event =>
                    onChangeValue('tableTitle', event.target.value)
                  }
                />
              </div>
            </div>
          </div>

          <div className='col-12 d-flex justify-content-end p-0 my-3'>
            <button
              type='button'
              onClick={event => onReset(event)}
              className='btn btn-danger w-5 mx-2'
            >
              {locales('fields.reset')}
            </button>
            <button type='submit' className='btn btn-success w-5 mx-2'>
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </section>
  );
};

export default CafeTimesFilters;
